import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { DocumentNarrative } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class DocumentNarrativeService extends TmsWebBaseEditCreateService<DocumentNarrative, DocumentNarrative> {
  constructor() {
    super('DocumentNarrative', $localize`Document Narrative`);
  }
  /**
   * Every document, flagged with whether this narrative is linked to it — drives the Narrative
   * screen's Documents tab, where the user ticks which documents a narrative prints on.
   */
  getDocumentsForNarrative(narrativeId: string): Observable<DocumentNarrative[]> {
    return this.httpService.get<DocumentNarrative[]>(
      `${this.apiUrl}/GetDocumentsForNarrative?narrativeId=${narrativeId}`,
    );
  }

  /**
   * The narratives linked to ONE document, in the order they print — drives the Document screen's
   * Narratives tab.
   *
   * ⚠️ The inverse of `getDocumentsForNarrative`, and easy to confuse: that tab used to call the
   * other method with a **document** id in the narrativeId parameter, matched nothing, and listed
   * every document with blank columns.
   */
  getNarrativesForDocument(documentId: string): Observable<DocumentNarrative[]> {
    return this.httpService.get<DocumentNarrative[]>(
      `${this.apiUrl}/GetNarrativesForDocument?documentId=${documentId}`,
    );
  }

  updateNarrativeDocuments(
    narrativeId: string,
    documentIds: string[],
    printOnAllDocuments: boolean[],
  ): Observable<void> {
    return this.httpService.post(`${this.apiUrl}/UpdateNarrativeDocuments`, {
      narrativeId,
      documentIds,
      printOnAllDocuments,
    });
  }
}
